module.exports = __webpack_public_path__ + "static/media/woo10.168b5581.png";